/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Terms_Ranking_AnchorInputs */

const en_legal_terms_ranking_anchor = /** @type {(inputs: Legal_Terms_Ranking_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4-how-results-are-ordered`)
};

const pl_legal_terms_ranking_anchor = /** @type {(inputs: Legal_Terms_Ranking_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4-jak-ustalamy-kolejnosc-wynikow`)
};

/**
* | output |
* | --- |
* | "4-how-results-are-ordered" |
*
* @param {Legal_Terms_Ranking_AnchorInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_terms_ranking_anchor = /** @type {((inputs?: Legal_Terms_Ranking_AnchorInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Terms_Ranking_AnchorInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_terms_ranking_anchor(inputs)
	return en_legal_terms_ranking_anchor(inputs)
});